import { Link } from "react-router-dom";
import React from "react";
import "../styles/SoftwareWebEngineering.css";

const buildCards = [
  {
    title: "Web Applications",
    description: "Responsive and high-performance applications designed around real business requirements.",
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=900&q=85",
    alt: "Code displayed on a developer's screen",
  },
  {
    title: "Enterprise Software",
    description: "Reliable software solutions that connect teams, processes and business operations.",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=900&q=85",
    alt: "Modern team workspace for enterprise collaboration",
  },
  {
    title: "API & Backend Systems",
    description: "Secure backend services and APIs built for integration and future growth.",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=900&q=85",
    alt: "Server infrastructure powering backend systems",
  },
];

const SoftwareWebEngineering = () => {
  return (
    <div className="swe-page">

      {/* 1. Hero Section */}
      <section className="swe-hero">
        <div className="swe-hero-content">
          <span>IT SERVICE 01</span>
          <h1>Software & Web Engineering</h1>
          <p>
            We design and build scalable web applications, enterprise
            platforms and modern software experiences that help businesses
            operate smarter.
          </p>
        </div>

        <div className="swe-hero-image">
          <img
            src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=90"
            alt="Software Engineering"
          />
        </div>
      </section>

      {/* 2. Capabilities */}
      <section className="swe-capabilities">
        <h2>What We Build</h2>
        <p className="section-intro">
          From business websites to complex digital platforms, our engineering
          approach focuses on performance, usability and scalability.
        </p>

        <div className="swe-grid">
          {buildCards.map((card) => (
            <article className="swe-card" key={card.title}>
              <img src={card.image} alt={card.alt} loading="lazy" />
              <div className="swe-card-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* 3. Development Approach */}
      <section className="swe-process">
        <div>
          <span>OUR APPROACH</span>
          <h2>From Idea to Digital Product</h2>
        </div>

        <div className="swe-steps">
          <div><b>01</b><p>Discover</p></div>
          <div><b>02</b><p>Design</p></div>
          <div><b>03</b><p>Develop</p></div>
          <div><b>04</b><p>Deploy & Improve</p></div>
        </div>
      </section>

      {/* 4. CTA */}
      <section className="swe-cta">
        <h2>Build Your Next Digital Product</h2>
        <p>
          Let's turn your business idea into a reliable and scalable
          technology solution.
        </p>
        <Link to="/contact">Start a Conversation →</Link>
      </section>

    </div>
  );
};

export default SoftwareWebEngineering;